import React from "react";
import { Phone, MessageCircle, Mail } from "lucide-react";

const SocialSidebar = () => {
  const socials = [
    { 
      icon: Phone, 
      href: "tel:+4915128958006", 
      label: "Anrufen",
      color: "hover:text-primary hover:bg-primary/10"
    },
    { 
      icon: MessageCircle, 
      href: "https://wa.me/4915128958006?text=Hallo%2C%20ich%20habe%20eine%20Frage%20zum%20IT-Support.", 
      label: "WhatsApp",
      color: "hover:text-green-600 hover:bg-green-50",
      external: true
    },
    { 
      icon: Mail, 
      href: "mailto:kontakt@klartech-mueritz.de", 
      label: "E-Mail",
      color: "hover:text-blue-600 hover:bg-blue-50"
    },
  ];

  return (
    <div className="fixed right-0 top-1/2 -translate-y-1/2 z-40 hidden lg:flex flex-col items-center gap-1 bg-background/90 backdrop-blur-md border border-r-0 border-border rounded-l-2xl shadow-lift p-2">
      {/* Vertical label */}
      <div className="py-3">
        <span
          className="text-xs font-bold text-navy/60 tracking-widest uppercase"
          style={{ writingMode: 'vertical-rl', textOrientation: 'mixed' }}
        >
          Kontakt
        </span>
      </div>

      <div className="w-8 h-px bg-gradient-to-r from-transparent via-flame/50 to-transparent my-1" />
      
      {/* Social icons */}
      {socials.map((social, i) => (
        <a
          key={i}
          href={social.href}
          target={social.external ? "_blank" : undefined}
          rel={social.external ? "noopener noreferrer" : undefined}
          className={`p-3 rounded-lg text-muted-foreground transition-all duration-200 ${social.color}`}
          aria-label={social.label}
        >
          <social.icon className="h-5 w-5" />
        </a>
      ))}
    </div>
  );
};

export default SocialSidebar;
